export default {"src":"/_next/static/media/vercel.55943d23.svg","height":48,"width":240,"blurWidth":0,"blurHeight":0};